<script setup>
import { computed } from 'vue'
import { DropdownMenuTrigger, useForwardProps } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  hideArrow: { type: Boolean, required: false },
})

const delegatedProps = computed(() => {
  const { hideArrow, ...delegated } = props
  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DropdownMenuTrigger :class="!hideArrow && 'dropdown-toggle'" v-bind="forwardedProps">
    <slot />
  </DropdownMenuTrigger>
</template>

<style lang="scss" scoped>
.dropdown-toggle {
  &[data-state='open'] {
    color: var(--gu-btn-active-color);
    background-color: var(--gu-btn-active-bg);
    border-color: var(--gu-btn-active-border-color);
  }
}
</style>
